import React from "react";
import TableWrapper from "../Table/tableWrapper";
import {useSelector} from "react-redux";
import {getUsageTable} from "../../Util/TableHelpers/usageTableHelper";
import { plansSelector } from "../../Reducers/plansReducer";

const UsageTableHeaders = ["Service Period", "Total Number of Accounts", "Total Number of Billed Accounts", "Total Usage Cost($)", "Total Discount($)", "Amount Due($)", "Details"]

const UsageTableSection = () => {
    const partnerDetails = useSelector(state => state.partnerDetails);
    const partnerAccountsObj = useSelector(state => state.partnerAccounts);
    const billingDataObj = useSelector(state => state.partnerBillingData);
    const plansObj = useSelector(plansSelector);

    if (billingDataObj === null || partnerDetails == null || partnerAccountsObj == null)
        return (
            <div className="p-2 ps-0 min-width-md-parent">
                <TableWrapper tableHeaderArr={UsageTableHeaders} tableBodyArr={[]}
                              errorText="You do not have any usage"/>
            </div>
        )

    const tableBodyArr = getUsageTable(billingDataObj.billingFormattedObj, partnerDetails.billingDiscountAmount, partnerAccountsObj, plansObj);
    UsageTableHeaders[4] = "Total Discount($)" + ` (${partnerDetails.billingDiscountAmount}%)`;

    return (
        <div className="p-2 ps-0 min-width-md-parent">
            <TableWrapper tableHeaderArr={UsageTableHeaders} tableBodyArr={tableBodyArr}/>
        </div>
    )
}

export default UsageTableSection;

